var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArtLockPeriod = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEF0EE",
  fillRule: "evenodd",
  d: "M138.645 51.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.991-17.799 24.371-49.655 30.598-78.733 22.523-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M114 68c0-13.255 10.745-24 24-24h52c13.255 0 24 10.745 24 24z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 24,
  x: 136,
  y: 32,
  fill: "#223B90",
  rx: 6
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 24,
  x: 180,
  y: 32,
  fill: "#223B90",
  rx: 6
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#223B90",
  fillRule: "evenodd",
  d: "M214 68H114v48c0 13.255 10.745 24 24 24h48.761A25.88 25.88 0 0 1 182 125c0-14.359 11.641-26 26-26 2.065 0 4.074.24 6 .696z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F23015",
  fillRule: "evenodd",
  d: "M207 144c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20m3.755-29.729a2.987 2.987 0 0 1 4.162-.732 2.995 2.995 0 0 1 .732 4.15l-4.144 5.919 5.919 4.144a2.99 2.99 0 0 1 .734 4.163 2.99 2.99 0 0 1-4.163.735l-5.919-4.145-4.145 5.919a2.987 2.987 0 0 1-4.163.734 2.99 2.99 0 0 1-.734-4.163l4.144-5.919-5.918-4.144a2.99 2.99 0 0 1-.734-4.164 2.99 2.99 0 0 1 4.163-.734l5.92 4.146 4.145-5.907zm1.393.978h.001l-5.123 7.3zm2.823 16.006-7.313-5.12zm-14.226 2.509h-.001a1.287 1.287 0 0 1-.316-1.793l5.121-7.313-7.313-5.121a1.285 1.285 0 1 0 0 0l7.313 5.121-5.12 7.313a1.285 1.285 0 0 0 .316 1.793",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 87,
  r: 6,
  fill: "#fff"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 113,
  r: 6,
  fill: "#fff"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 87,
  r: 6,
  fill: "#fff"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 113,
  r: 6,
  fill: "#fff"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 192,
  cy: 87,
  r: 6,
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F23015",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m105.643 13.737 9.793 19.882M76.549 63.937l20.43-2.528M76.61 29.933l27.038 16.017"
})));
export default SvgArtLockPeriod;